export default {
    de: {
        title: 'Beratung',
        preferredTimeLabel: 'Wann erreichen wir Sie am besten?',
        preferredTimeRequiredError: 'Please, select at least one element',
        preferredTime_8_10: '8 - 10 Uhr',
        preferredTime_10_12: '10 - 12 Uhr',
        preferredTime_12_14: '12 - 14 Uhr',
        preferredTime_14_16: '14 - 16 Uhr',
        preferredTime_16_18: '16 - 18 Uhr',
        preferredTime_18: 'nach 18 Uhr',
        preferredTime_always: 'Ich bin immer erreichbar',
        preferredChannelLabel: 'Welche Art des Beratungsgespräches bevorzugen Sie?',
        commentLabel: 'Haben Sie noch Wünsche für Ihre Beratung?',
        submitBtnTitle: 'Anfrage abschließen',
        submitBtnSubTitle: 'kostenlos und unverbindlich',
    },
};
